import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mobile-configuration-details-modal',
  templateUrl: './mobile-configuration-details-modal.component.html',
  styleUrls: ['./mobile-configuration-details-modal.component.less']
})
export class MobileConfigurationDetailsModalComponent implements OnInit {
  @Input() mobileEnvironmentDetails : any;
  @Input() mobileEnvironmentArray : any;
  @Input() mostRecentExecuted: any;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    let temArray = [];
    for (const property in this.mobileEnvironmentDetails) {
      let tempObject = {
        key : property,
        value : this.mobileEnvironmentDetails[property]
      }
      temArray.push(tempObject);
    }
    this.mobileEnvironmentArray = temArray;
  }

  cancelModal() {
    this.activeModal.close(false);
  }
}